import { useEffect } from "react"
import { useToast } from "../../utils/ToastProvider"

export const Toaster = () => {
  const { toasts, removeToast } = useToast()

  useEffect(() => {
    const timer = setInterval(() => {
      if (toasts.length > 0) {
        removeToast(toasts[0].id)
      }
    }, 3000)

    return () => clearInterval(timer)
  }, [toasts, removeToast])

  return (
    <div className="fixed min-w-[300px] bottom-4 right-4 z-50">
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast} onClose={() => removeToast(toast.id)} />
      ))}
    </div>
  )
}


export const Toast = ({ title, description, type = "success", onClose }) => {
  const baseClasses = "mb-4 p-4 rounded-md shadow-md transition-all duration-300 ease-in-out"
  const typeClasses = {
    info: "bg-blue-500 text-white",
    success: "bg-primary text-white",
    warning: "bg-yellow-500 text-white",
    error: "bg-red-500 text-white",
  }

  return (
    <div className={`${baseClasses} ${typeClasses[type]}`}>
      <div className="flex justify-between items-center">
        <h3 className="font-bold mb-0">{title}</h3>
        <button onClick={onClose} className="text-white">
          &times;
        </button>
      </div>
      {description && <p className="mt-2 pr-4">{description}</p>}
    </div>
  )
}

